module.exports = __webpack_public_path__ + "img/scroll-top.6153a73f.svg";